import { useQueryClient } from "@tanstack/react-query";
import { useOrg } from "@/hooks/data";
import { useApiQuery } from "@/lib/api/hooks";

/** The org's agents (list + pickers share the cache). */
export const useAgents = () => useApiQuery("agents", {}, { staleTime: 15_000 });

/** Admins (and owners) manage agents; editors try them, draft and assign per conversation. */
export function useAgentRole(): { manage: boolean; write: boolean } {
  const role = useOrg()?.role ?? null;
  return { manage: role === "owner" || role === "admin", write: role === "owner" || role === "admin" || role === "editor" };
}

/** Refresh everything agent-shaped after a change. */
export function useRefreshAgents() {
  const qc = useQueryClient();
  return () =>
    Promise.all(
      ["agents", "agent", "agentOverview", "agentAssignments", "agentUsage", "agentRuns", "agentVersions", "resolveAgent", "approvals", "inboxCounts", "inbox", "conversation"].map((k) => qc.invalidateQueries({ queryKey: [k] })),
    );
}
